export default {"src":"/_next/static/media/Group-25850.a5d243a9.svg","height":104,"width":104};